var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _path4, _path5, _path6, _defs4, _path7, _defs5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253 19",
    style: {
      enableBackground: "new 0 0 253 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000125574158187252721940000008345675547903719076_);}\n\t.st1{fill:#007BC1;}\n\t.st2{clip-path:url(#SVGID_00000131343211995936723050000007305366223233383830_);}\n\t.st3{fill:#F68121;}\n\t.st4{clip-path:url(#SVGID_00000033346232200395185310000009156053895720571029_);}\n\t.st5{fill:#FF5F00;}\n\t.st6{fill:#EB001B;}\n\t.st7{fill:#F79E1B;}\n\t.st8{clip-path:url(#SVGID_00000009574947129277487310000010300912695898140339_);}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:url(#SVGID_00000075848091067295533350000016258669724016229506_);}\n\t.st11{fill:url(#SVGID_00000013898812974692676810000000145620377469002402_);}\n\t.st12{fill:url(#SVGID_00000046322728603272364550000017290655845570295169_);}\n\t.st13{fill:url(#SVGID_00000018209172690387067740000017164184997323388857_);}\n\t.st14{fill:url(#SVGID_00000133525421645891310930000004666627885887033236_);}\n\t.st15{clip-path:url(#SVGID_00000122689866676611438380000010351626404758705591_);}\n\t.st16{fill:#004A97;}\n\t.st17{fill:#0157A2;}\n\t.st18{fill:#383E41;}\n\t.st19{fill:#0085F7;}\n\t.st20{fill:#00A94B;}\n\t.st21{fill:#FFBB00;}\n\t.st22{fill:#FF4031;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 171.9,
    y: 1.9,
    width: 21.4,
    height: 14.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161591542994294019390000017467587841531446450_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000161591542994294019390000017467587841531446450_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.9,16.2h-18.5c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-6h1l0.2-0.6h0.5l0.2,0.6h2V8.3l0.2,0.4h1 l0.2-0.4v0.4h5V7.8h0.1c0.1,0,0.1,0,0.1,0.1v0.8h2.6V8.5c0.3,0.1,0.6,0.2,0.9,0.2l0.1,0h0h1.1l0.2-0.6h0.5l0.2,0.6h2.1V8.2 l0.3,0.5h1.7V5.2h-1.7v0.4l-0.2-0.4h-1.7v0.4l-0.2-0.4h-2.3c-0.4,0-0.7,0.1-1,0.2l0,0V5.2h-1.6v0.2c-0.2-0.2-0.4-0.2-0.7-0.2h0 h-5.8l-0.4,0.9l-0.4-0.9h-1.8v0.4l-0.2-0.4h-1.6l-0.7,1.7V3.3c0-0.4,0.2-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4h18.5 c0.4,0,0.7,0.2,1,0.4c0.3,0.3,0.4,0.6,0.4,1v6.2h-1.1c0,0,0,0-0.1,0c-0.3,0-0.5,0.1-0.7,0.2l0,0V9.6h-1.6c-0.3,0-0.5,0.1-0.7,0.2 l0,0V9.6h-2.9v0.2c-0.2-0.1-0.5-0.2-0.8-0.2h0h0h-1.9v0.2c-0.3-0.2-0.6-0.2-0.9-0.2l0,0h-2.2l-0.5,0.5l-0.5-0.5h-3.2v3.5h3.2 l0.5-0.5l0.5,0.5h2v-0.8h0.3c0.3,0,0.5,0,0.8-0.1l0,0v0.9h1.6v-0.9h0.1c0.1,0,0.1,0,0.1,0.1v0.8h4.9l0.1,0c0.3,0,0.5-0.1,0.8-0.2 l0,0v0.2h1.6l0.1,0c0.3,0,0.6-0.1,0.8-0.2l0,0v1.8c0,0.4-0.2,0.7-0.4,1C192.6,16,192.3,16.2,191.9,16.2L191.9,16.2z M184.5,12.6 h-0.6v-2.5h1.4c0.3,0,0.5,0,0.7,0.1l0,0c0.2,0.1,0.3,0.3,0.3,0.5l0,0v0l0,0c0,0.3-0.2,0.5-0.4,0.6l0,0c0.1,0,0.2,0.1,0.3,0.2l0,0 c0.1,0.1,0.1,0.3,0.1,0.5v0v0.5h-0.6v-0.3c0-0.2,0-0.3-0.1-0.5l0,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0l0,0h-0.6V12.6 L184.5,12.6z M184.5,10.6v0.6h0.7c0.1,0,0.2,0,0.3-0.1l0,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1v0v0c0,0,0-0.1,0-0.1 c0,0-0.1-0.1-0.1-0.1l0,0c-0.1,0-0.2-0.1-0.3,0h0L184.5,10.6z M179.1,12.6h-2.4v-2.5h2.4l0.7,0.8l0.8-0.8h1.9c0.7,0,1,0.3,1,0.8 c0,0.6-0.3,0.8-1,0.8h-0.8v0.8h-1.2l-0.7-0.8L179.1,12.6L179.1,12.6z M181.2,10.3l-0.9,1l0.9,1V10.3z M177.3,11.6v0.5h1.5l0.7-0.7 l-0.7-0.7h-1.5V11h1.3v0.5L177.3,11.6z M181.8,10.6v0.6h0.8c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.1-0.3-0.4-0.3L181.8,10.6z M192.5,12.6 h-1.2V12h1.2c0.1,0,0.2,0,0.2-0.1v0c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.1v0c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1 h0l-0.1,0c-0.5,0-1.2,0-1.2-0.8c0-0.4,0.2-0.7,0.9-0.7h1.2v0.5h-1.1c-0.1,0-0.2,0-0.2,0l0,0c0,0-0.1,0-0.1,0.1s0,0.1,0,0.1v0v0 c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2,0,0.2,0h0l0.3,0c0.2,0,0.5,0,0.7,0.2l0,0c0,0,0,0,0,0l0,0l0,1 c-0.1,0.1-0.2,0.2-0.4,0.3C192.8,12.6,192.6,12.6,192.5,12.6L192.5,12.6z M190.2,12.6H189V12h1.2c0.1,0,0.2,0,0.2-0.1l0,0 c0,0,0,0,0.1-0.1c0,0,0-0.1,0-0.1v0c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1h0l-0.1,0c-0.5,0-1.2,0-1.2-0.8 c0-0.4,0.2-0.7,0.9-0.7h1.2v0.5h-1.1c-0.1,0-0.2,0-0.2,0l0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2,0,0.2,0h0l0.3,0c0.2,0,0.5,0,0.7,0.2l0,0c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.3v0 C191.1,12.3,190.8,12.6,190.2,12.6L190.2,12.6z M188.6,12.6h-2v-2.5h2v0.5h-1.4V11h1.4v0.5h-1.4v0.5l1.4,0V12.6L188.6,12.6z  M189.8,8.2h-1.2l-0.2-0.6h-1.2l-0.2,0.6h-0.7c-0.3,0-0.6-0.1-0.9-0.3l0,0c-0.1-0.1-0.2-0.3-0.3-0.4C185,7.4,184.9,7.2,185,7v0 c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.1-0.3,0.3-0.5l0,0c0.1-0.1,0.3-0.2,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.1l0,0h0.6v0.5h-0.6 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0.1-0.2,0.1l0,0c-0.1,0.2-0.2,0.4-0.2,0.6v0c0,0.2,0,0.4,0.2,0.6l0,0c0.1,0.1,0.3,0.1,0.4,0.1h0 h0.3l0.9-2h0.9l1,2.4V5.7h0.9l1.1,1.8V5.7h0.6v2.5h-0.9l-1.1-1.9L189.8,8.2L189.8,8.2z M187.7,6.2l-0.4,1h0.8L187.7,6.2z  M181.9,8.2h-0.6V5.7h1.4c0.3,0,0.5,0,0.7,0.1l0,0c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3l0,0v0v0c0,0.1,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.2-0.3,0.3l0,0c0.1,0,0.2,0.1,0.3,0.2l0,0c0.1,0.1,0.1,0.3,0.1,0.5l0,0v0.5h-0.6l0-0.3v0c0-0.2,0-0.3-0.1-0.4l0,0 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0l0,0h-0.6L181.9,8.2L181.9,8.2z M181.9,6.3v0.6h0.7c0.1,0,0.2,0,0.3-0.1l0,0 c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1v0v0c0,0,0-0.1,0-0.1s-0.1-0.1-0.1-0.1l0,0c-0.1,0-0.2-0.1-0.3,0h0L181.9,6.3z M175.5,8.2 h-1.2l-0.2-0.6h-1.3l-0.2,0.6h-0.7l1.1-2.5h0.9l1,2.4V5.7h1l0.8,1.7l0.7-1.7h1v2.5h-0.6l0-2l-0.9,2h-0.5l-0.9-2L175.5,8.2 L175.5,8.2z M173.4,6.2l-0.4,1h0.8L173.4,6.2z M184.7,8.2H184V5.7h0.6L184.7,8.2L184.7,8.2z M180.9,8.2h-2V5.7h2v0.5h-1.4v0.5h1.4 v0.5h-1.4v0.5h1.4L180.9,8.2L180.9,8.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121974915568920613200000012386656094177152644_",
    x: 145.3,
    width: 18.1,
    height: 18.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067924723787272012650000017316444267328698765_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121974915568920613200000012386656094177152644_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000067924723787272012650000017316444267328698765_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.6,7.2c0-0.2-0.2-0.4-0.5-0.4H161v0.8h0.1C161.4,7.6,161.6,7.4,161.6,7.2z M161.9,2h-15.1 c-0.4,0-0.8,0.2-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1v11c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4h15.1c0.4,0,0.8-0.2,1.1-0.4 c0.3-0.3,0.4-0.7,0.4-1.1v-11c0-0.4-0.2-0.8-0.4-1.1C162.6,2.2,162.2,2,161.9,2z M160.5,6.4c0.7,0,1.7-0.1,1.7,0.8 c0,0.4-0.2,0.6-0.6,0.7l0.8,1.1h-0.6l-0.7-1H161v1h-0.5V6.4z M158.7,6.4h1.4v0.4h-0.9v0.6h0.9v0.4h-0.9v0.7h0.9v0.4h-1.4V6.4z  M156.6,6.4l0.7,1.7l0.7-1.7h0.5L157.4,9h-0.3L156,6.4H156.6z M154.8,6.3c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.5,0.3 c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.5c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3 s-0.4,0.1-0.5,0.1c-0.2,0-0.4,0-0.5-0.1s-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0-0.4,0.1-0.5 c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.3C154.4,6.3,154.6,6.3,154.8,6.3z M153.3,6.5v0.6c-0.6-0.6-1.5-0.1-1.5,0.6 c0,0.8,0.9,1.2,1.5,0.6v0.6c-0.9,0.4-2-0.2-2-1.2C151.3,6.7,152.3,6,153.3,6.5L153.3,6.5z M150.2,8.5c0.4,0,0.7-0.5-0.1-0.8 c-0.5-0.2-0.6-0.4-0.6-0.7c0-0.7,1-1,1.6-0.4L150.8,7C150.4,6.6,150,6.8,150,7c0,0.1,0.1,0.2,0.4,0.3c0.6,0.2,0.7,0.4,0.7,0.8 c0,0.9-1.2,1.2-1.8,0.4l0.3-0.3C149.8,8.4,150,8.5,150.2,8.5L150.2,8.5z M147,8.9h-0.7V6.4h0.7c0.8,0,1.4,0.5,1.4,1.3 C148.4,8.2,148,8.9,147,8.9L147,8.9z M149.1,8.9h-0.5V6.4h0.5V8.9z M162.4,14.6c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1 h-12.6c5.9-1.1,12-4.4,13.1-5V14.6z M147.6,7c-0.2-0.2-0.4-0.2-0.7-0.2h-0.1v1.7h0.1c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.2,0.3-0.4,0.3-0.6C147.9,7.4,147.8,7.2,147.6,7z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075139580704954398380000006045254176217596832_",
    x: 118.4,
    y: 1.9,
    width: 18.4,
    height: 14.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056402443437889759380000017585197589996779431_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075139580704954398380000006045254176217596832_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056402443437889759380000017585197589996779431_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.7,16.1v-0.9c0-0.4-0.2-0.6-0.6-0.6c-0.2,0-0.4,0.1-0.5,0.3c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2,0-0.3,0-0.4,0.2v-0.2h-0.3 v1.5h0.3v-0.8c0-0.3,0.1-0.4,0.4-0.4c0.2,0,0.3,0.1,0.3,0.4v0.8h0.3v-0.8c0-0.3,0.2-0.4,0.4-0.4c0.2,0,0.3,0.1,0.3,0.4v0.8H121.7z  M126.6,14.6h-0.5v-0.5h-0.3v0.5h-0.3v0.3h0.3v0.7c0,0.3,0.1,0.6,0.5,0.6c0.1,0,0.3,0,0.4-0.1l-0.1-0.3c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.2,0-0.2-0.1-0.2-0.3v-0.7h0.5V14.6z M129.4,14.6c-0.2,0-0.3,0.1-0.4,0.2v-0.2h-0.3v1.5h0.3v-0.8c0-0.3,0.1-0.4,0.3-0.4 c0.1,0,0.1,0,0.2,0l0.1-0.3C129.6,14.6,129.5,14.6,129.4,14.6L129.4,14.6z M125.2,14.7c-0.2-0.1-0.4-0.2-0.6-0.2 c-0.4,0-0.6,0.2-0.6,0.5c0,0.3,0.2,0.4,0.5,0.4l0.2,0c0.2,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.5-0.2 l-0.2,0.3c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.7-0.2,0.7-0.5c0-0.3-0.2-0.4-0.5-0.5l-0.2,0c-0.1,0-0.3,0-0.3-0.1 c0-0.1,0.1-0.2,0.3-0.2c0.2,0,0.4,0.1,0.5,0.1L125.2,14.7z M134,14.6c-0.2,0-0.3,0.1-0.4,0.2v-0.2h-0.3v1.5h0.3v-0.8 c0-0.3,0.1-0.4,0.3-0.4c0.1,0,0.1,0,0.2,0l0.1-0.3C134.1,14.6,134,14.6,134,14.6z M129.7,15.3c0,0.5,0.3,0.8,0.8,0.8 c0.2,0,0.4,0,0.5-0.2l-0.2-0.3c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.1,0,0.3,0,0.4,0.1 l0.2-0.3c-0.2-0.1-0.3-0.2-0.5-0.2C130.1,14.6,129.7,14.9,129.7,15.3z M132.8,15.3v-0.8h-0.3v0.2c-0.1-0.1-0.3-0.2-0.5-0.2 c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.2,0,0.4-0.1,0.5-0.2v0.2h0.3V15.3z M131.6,15.3c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5C131.8,15.8,131.6,15.6,131.6,15.3z M127.6,14.6c-0.4,0-0.8,0.3-0.8,0.8 c0,0.5,0.3,0.8,0.8,0.8c0.2,0,0.4-0.1,0.6-0.2l-0.2-0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.4-0.1-0.5-0.4h1.1v-0.1 C128.3,14.9,128.1,14.6,127.6,14.6L127.6,14.6z M127.6,14.8c0.2,0,0.3,0.1,0.4,0.4h-0.8C127.2,15,127.4,14.8,127.6,14.8z  M135.8,15.3V14h-0.3v0.8c-0.1-0.1-0.3-0.2-0.5-0.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.2,0,0.4-0.1,0.5-0.2v0.2h0.3V15.3z  M134.6,15.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5C134.8,15.8,134.6,15.6,134.6,15.3z M123.6,15.3 v-0.8h-0.3v0.2c-0.1-0.1-0.3-0.2-0.5-0.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0.2,0,0.4-0.1,0.5-0.2v0.2h0.3V15.3z  M122.3,15.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5C122.5,15.8,122.3,15.6,122.3,15.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.1,3.1h5V12h-5V3.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M125.4,7.6c0-1.8,0.8-3.4,2.2-4.5c-1-0.8-2.2-1.2-3.5-1.2c-3.1,0-5.7,2.5-5.7,5.7c0,3.1,2.5,5.7,5.7,5.7 c1.3,0,2.5-0.5,3.5-1.2C126.2,11,125.4,9.4,125.4,7.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136.7,7.6c0,3.1-2.5,5.7-5.7,5.7c-1.3,0-2.5-0.5-3.5-1.2c1.3-1,2.2-2.6,2.2-4.5s-0.8-3.4-2.2-4.5 c1-0.8,2.2-1.2,3.5-1.2C134.2,1.9,136.7,4.5,136.7,7.6L136.7,7.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100341926253888777040000016004419199204027057_",
    x: 231.8,
    y: 1,
    width: 21,
    height: 16.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059288034742059938060000007702129716945821844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100341926253888777040000016004419199204027057_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059288034742059938060000007702129716945821844_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252.8,13.8c0,1.8-1.5,3.3-3.3,3.3h-17.7V4.2c0-1.8,1.5-3.3,3.3-3.3h17.7V13.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046339705860193374350000007769720270786651314_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.887,
    y1: 10.0805,
    x2: 251.645,
    y2: 10.0805,
    gradientTransform: "matrix(1 0 0 -1 0 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046339705860193374350000007769720270786651314_)"
    },
    d: "M247,10.5h1.3c0,0,0.1,0,0.2,0 c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.2-0.5-0.5-0.6c0,0-0.1,0-0.2,0H247V10.5L247,10.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035508648076018249390000013266859614316397230_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.887,
    y1: 10.9711,
    x2: 251.64,
    y2: 10.9711,
    gradientTransform: "matrix(1 0 0 -1 0 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035508648076018249390000013266859614316397230_)"
    },
    d: "M248.2,2c-1.3,0-2.3,1-2.3,2.3v2.4h3.3 c0.1,0,0.2,0,0.2,0c0.7,0,1.3,0.4,1.3,1.1c0,0.5-0.4,1-1.1,1.1v0c0.8,0.1,1.3,0.5,1.3,1.1c0,0.7-0.6,1.2-1.5,1.2h-3.6V16h3.4 c1.3,0,2.3-1,2.3-2.3V2H248.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173133304615134934360000016024217940786220453_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.887,
    y1: 11.9511,
    x2: 251.645,
    y2: 11.9511,
    gradientTransform: "matrix(1 0 0 -1 0 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173133304615134934360000016024217940786220453_)"
    },
    d: "M248.8,8c0-0.3-0.2-0.5-0.5-0.6 c0,0-0.1,0-0.1,0H247v1.1h1.2c0,0,0.1,0,0.1,0C248.6,8.6,248.8,8.4,248.8,8L248.8,8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122709712037720186250000000221640437556137105_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.998,
    y1: 10.9775,
    x2: 238.845,
    y2: 10.9775,
    gradientTransform: "matrix(1 0 0 -1 0 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F286F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#004E94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      stopColor: "#0066B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006FBC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122709712037720186250000000221640437556137105_)"
    },
    d: "M235.3,2c-1.3,0-2.3,1-2.3,2.3v5.8 c0.7,0.3,1.3,0.5,2,0.5c0.8,0,1.2-0.5,1.2-1.2V6.8h2v2.7c0,1.1-0.7,1.9-2.9,1.9c-1.3,0-2.4-0.3-2.4-0.3V16h3.4 c1.3,0,2.3-1,2.3-2.3V2L235.3,2L235.3,2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065066901529653513050000007602353409727819439_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.412,
    y1: 10.9647,
    x2: 245.09,
    y2: 10.9647,
    gradientTransform: "matrix(1 0 0 -1 0 20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C2C2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    style: {
      stopColor: "#882730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    style: {
      stopColor: "#BE1833"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#DC0436"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E60039"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065066901529653513050000007602353409727819439_)"
    },
    d: "M241.8,2c-1.3,0-2.3,1-2.3,2.3v3 c0.6-0.5,1.6-0.8,3.3-0.7c0.9,0,1.8,0.3,1.8,0.3v1c-0.5-0.2-1-0.5-1.8-0.5c-1.3-0.1-2,0.5-2,1.6c0,1.1,0.8,1.7,2,1.6 c0.7-0.1,1.3-0.3,1.8-0.5v1c0,0-0.9,0.2-1.8,0.3c-1.7,0.1-2.7-0.2-3.3-0.7V16h3.4c1.3,0,2.3-1,2.3-2.3V2L241.8,2L241.8,2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120559699294923656870000001584667603529350819_",
    x: 201.9,
    y: 1.9,
    width: 21.4,
    height: 14.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052063228602448072750000013451551795123243957_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120559699294923656870000001584667603529350819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052063228602448072750000013451551795123243957_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M209.8,12.2V5.8c-0.7,0.3-1.2,0.7-1.6,1.3c-0.4,0.6-0.6,1.2-0.6,2c0,0.7,0.2,1.4,0.6,2 C208.7,11.6,209.2,12,209.8,12.2z M214.5,9c0-0.7-0.2-1.4-0.6-2c-0.4-0.6-0.9-1-1.6-1.3v6.4c0.7-0.3,1.2-0.7,1.6-1.3 C214.3,10.4,214.5,9.8,214.5,9z M216.5,9c0,1-0.2,1.9-0.7,2.7c-0.5,0.8-1.1,1.5-2,2c-0.8,0.5-1.7,0.7-2.7,0.7 c-0.7,0-1.4-0.1-2.1-0.4c-0.7-0.3-1.2-0.7-1.7-1.2c-0.5-0.5-0.9-1.1-1.2-1.7c-0.3-0.7-0.4-1.4-0.4-2.1c0-1,0.2-1.9,0.7-2.7 c0.5-0.8,1.1-1.5,2-2s1.7-0.7,2.7-0.7c1,0,1.9,0.2,2.7,0.7s1.5,1.1,2,2C216.3,7.1,216.5,8,216.5,9z M220.1,9.1 c0-0.9-0.2-1.7-0.5-2.4c-0.3-0.8-0.8-1.4-1.4-1.9c-0.6-0.5-1.2-0.9-2-1.2c-0.8-0.3-1.5-0.4-2.3-0.4h-2.8c-1.1,0-2.1,0.3-3,0.8 c-0.9,0.5-1.6,1.2-2.2,2.1c-0.5,0.9-0.8,2-0.8,3.1c0,1.1,0.3,2,0.8,2.9c0.5,0.9,1.3,1.6,2.2,2.2c0.9,0.5,1.9,0.8,3,0.8h2.8 c0.8,0,1.6-0.2,2.3-0.5c0.8-0.3,1.4-0.7,2-1.3c0.6-0.5,1-1.2,1.4-1.9C219.9,10.6,220.1,9.9,220.1,9.1z M223.3,3.1V15 c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.2-0.5,0.4-0.8,0.4h-19c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.4-0.8V3.1c0-0.3,0.1-0.6,0.4-0.8 c0.2-0.2,0.5-0.4,0.8-0.4h19c0.3,0,0.6,0.1,0.8,0.4C223.2,2.5,223.3,2.8,223.3,3.1z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M88,2c-0.5,0-0.9,0.4-0.9,0.9v12.4c0,0.5,0.4,0.9,0.9,0.9h20.9c0.5,0,0.9-0.4,0.9-0.9V2.9 c0-0.5-0.4-0.9-0.9-0.9H88z M100.7,6.3c0.6,0,1,0.1,1.3,0.2l-0.2,1.2l-0.1-0.1c-0.3-0.1-0.6-0.2-1.1-0.2c-0.6,0-0.8,0.2-0.8,0.5 c0,0.3,0.3,0.4,0.8,0.7c0.8,0.4,1.2,0.9,1.2,1.5c0,1.2-1,1.9-2.5,1.9c-0.6,0-1.3-0.1-1.6-0.3l0.2-1.3l0.2,0.1 c0.5,0.2,0.8,0.3,1.3,0.3c0.4,0,0.8-0.2,0.9-0.5c0-0.2-0.2-0.4-0.7-0.7c-0.5-0.3-1.3-0.7-1.3-1.5C98.3,7,99.3,6.3,100.7,6.3z  M89.1,6.4h2.3c0.3,0,0.6,0.1,0.6,0.4l0.5,2.6c0,0,0,0,0,0l0.1,0.8l1.4-3.8h1.5L93.4,12l-1.5,0l-1.2-4.5c0.7,0.4,1.3,0.8,1.7,1.4 c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.6-0.6-0.7-0.7c-0.6-0.5-1.3-0.9-2.1-1.1L89.1,6.4z M96.2,6.4h1.5L96.8,12h-1.5L96.2,6.4z  M104.6,6.4h1.1l1.2,5.5h-1.3c0,0-0.1-0.6-0.2-0.8c-0.2,0-1.7,0-1.9,0c-0.1,0.1-0.3,0.8-0.3,0.8h-1.5l2.2-5.1 C104,6.5,104.2,6.4,104.6,6.4z M104.7,7.9c-0.1,0.2-0.2,0.5-0.2,0.5c0,0-0.5,1.2-0.6,1.5l1.2,0c-0.1-0.5-0.2-1.1-0.3-1.6L104.7,7.9 L104.7,7.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M16.5,8.8v4.1h-1.3V2.7h3.4c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.9,1.3,0.9,2.1c0,0.9-0.3,1.6-0.9,2.1 c-0.6,0.6-1.3,0.9-2.2,0.9L16.5,8.8L16.5,8.8z M16.5,4v3.5h2.2c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.2 c0-0.5-0.2-0.9-0.5-1.2C19.6,4.2,19.2,4,18.7,4L16.5,4L16.5,4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M25.2,5.7c1,0,1.7,0.3,2.3,0.8s0.8,1.2,0.8,2.1v4.3h-1.2v-1H27c-0.5,0.8-1.3,1.2-2.1,1.2 c-0.8,0-1.4-0.2-1.9-0.7c-0.5-0.5-0.8-1-0.8-1.7c0-0.7,0.3-1.3,0.8-1.7c0.5-0.4,1.3-0.6,2.2-0.6c0.8,0,1.4,0.1,1.9,0.4V8.5 c0-0.5-0.2-0.8-0.5-1.2c-0.4-0.3-0.8-0.5-1.3-0.5c-0.7,0-1.3,0.3-1.7,0.9l-1.1-0.7C23.1,6.2,24,5.7,25.2,5.7z M23.5,10.7 c0,0.3,0.1,0.6,0.4,0.8c0.3,0.2,0.6,0.3,1,0.3c0.5,0,1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.4c-0.4-0.3-1-0.5-1.7-0.5 c-0.5,0-1,0.1-1.3,0.4C23.7,10,23.5,10.3,23.5,10.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.4,5.9l-4.3,10h-1.3l1.6-3.5l-2.9-6.5h1.4l2.1,5h0l2-5H35.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M11.2,6.7H5.8v2.2l3.1,0c-0.1,0.7-0.5,1.4-1.2,1.8v0c0,0,0,0,0,0l-0.1,1.3l1.9,0.1c0,0,0,0,0,0 c1.1-1,1.7-2.5,1.7-4.3C11.3,7.5,11.3,7.1,11.2,6.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M7.8,10.7C7.8,10.7,7.8,10.7,7.8,10.7c-0.5,0.4-1.2,0.6-2,0.6c-1.5,0-2.8-1-3.3-2.4h0c0,0,0,0,0,0L0.9,8.6 l-0.3,1.7c1,1.9,2.9,3.2,5.2,3.2c1.6,0,2.9-0.5,3.8-1.4c0,0,0,0,0,0L7.8,10.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M2.4,7.8c0-0.4,0.1-0.8,0.2-1.1L2,5.2H0.6C0.2,6,0,6.9,0,7.8c0,0.9,0.2,1.8,0.6,2.6l0,0l1.9-1.5c0,0,0,0,0,0 C2.4,8.6,2.4,8.2,2.4,7.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M5.8,2C3.5,2,1.6,3.3,0.6,5.2l1.9,1.5C3,5.3,4.3,4.3,5.8,4.3c0.9,0,1.6,0.3,2.2,0.9l1.7-1.7 C8.7,2.6,7.4,2,5.8,2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,3.9c0.4-0.5,0.7-1.2,0.6-1.9c-0.6,0-1.3,0.4-1.7,0.9c-0.4,0.4-0.7,1.1-0.6,1.8C49.6,4.8,50.3,4.4,50.7,3.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3,4.8c-1-0.1-1.8,0.5-2.3,0.5c-0.5,0-1.2-0.5-1.9-0.5c-1,0-1.9,0.6-2.4,1.5c-1,1.8-0.3,4.4,0.7,5.9 c0.5,0.7,1.1,1.5,1.9,1.5c0.7,0,1-0.5,1.9-0.5c0.9,0,1.2,0.5,1.9,0.5c0.8,0,1.3-0.7,1.8-1.4c0.6-0.8,0.8-1.6,0.8-1.7 c0,0-1.6-0.6-1.6-2.4c0-1.5,1.2-2.2,1.3-2.2C52.7,5,51.7,4.9,51.3,4.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7,2.8c2.1,0,3.6,1.4,3.6,3.6c0,2.1-1.5,3.6-3.6,3.6h-2.3v3.7h-1.7V2.8H59.7z M57.3,8.5h1.9c1.5,0,2.3-0.8,2.3-2.2 c0-1.4-0.8-2.1-2.3-2.1h-1.9V8.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,11.4c0-1.4,1.1-2.2,2.9-2.3l2.2-0.1V8.3c0-0.9-0.6-1.4-1.6-1.4c-0.9,0-1.5,0.5-1.7,1.2H64c0.1-1.4,1.3-2.5,3.3-2.5 c1.9,0,3.1,1,3.1,2.6v5.4h-1.6v-1.3h0c-0.5,0.9-1.5,1.4-2.5,1.4C64.8,13.8,63.7,12.8,63.7,11.4z M68.8,10.7v-0.6l-1.9,0.1 c-1,0.1-1.5,0.5-1.5,1.2c0,0.7,0.6,1.1,1.4,1.1C67.9,12.5,68.8,11.7,68.8,10.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9,16.6v-1.3c0.1,0,0.4,0,0.5,0c0.8,0,1.2-0.3,1.4-1.1c0,0,0.1-0.5,0.1-0.5l-2.9-7.9h1.8l2,6.4h0l2-6.4h1.7l-3,8.3 c-0.7,1.9-1.5,2.5-3.1,2.5C72.4,16.6,72,16.6,71.9,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.f4b1f36e1b84ae1c3ea500d2d441e9e6.svg";
export { ForwardRef as ReactComponent };